import React, { Component } from 'react'
import { Link } from "react-router-dom";
import axios from 'axios';
import { Redirect, NavLink } from "react-router-dom";
import "./../styles/navPersonalStyle.css";
import avatarPerson from '../images/avatar-person.svg';
import VentanaColores from "./VentanaColores";
import UserService from "../services/User.service";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export default class NavPersonal extends Component {
    state = {
        isOpen: false,
        logout: false,
        userData: ''
    }
    fadeOut = () => {
        this.setState({ isOpen: false });
    }
    fadeIn = () => {
        this.setState({ isOpen: true });
    }

    logoutHandler = async () => {
        const response = await UserService.logout();
        if (response.data.message === 'SESSION_CLOSED') {
            this.setState({ logout: true });
        } else {
            alert(`Error: ${response.data.message}`);
        }
    }

    async componentDidMount() {
        const response = await axios.get(`${SERVER_URL}/api/isLoggedIn`, { withCredentials: true });
        this.setState({ isLoggedIn: response.data.isLoggedIn, firstTime: false });

        if (response.data.isLoggedIn) {
            const response = await UserService.info();
            this.setState({ userData: response.data.user });
        }

        var btnMenu = document.getElementById("btnMenu"),
            menu = document.getElementById("menu"),
            fondo = document.getElementById("nav"),
            closeBTN = document.getElementById("CloseBTN"),
            closeLBL = document.getElementById("CloseLBL"),
            blackScreen = document.getElementById("blackScreen"),
            personOptions = document.getElementById("PersonOptions"),
            showPersonOptions = document.getElementById("Username");

        function closeAndOpenM() {
            fondo.classList.toggle("mostrarFondo");
            menu.classList.toggle("mostrarMenu");
        }
        btnMenu.addEventListener("click", closeAndOpenM);
        closeBTN.addEventListener("click", closeAndOpenM);
        closeLBL.addEventListener("click", closeAndOpenM);
        blackScreen.addEventListener("click", closeAndOpenM);

        function ShowPO() {
            personOptions.classList.toggle("showOptions");
        }
        showPersonOptions.addEventListener("click", ShowPO);
    }

    render() {
        return (this.state.logout)
            ? <Redirect to="/" />
            : (
                <div className="NavPersonal">
                    <VentanaColores isOpen={this.state.isOpen} closeWindow={this.fadeOut} />
                    <header>
                        <button className="btnMenu" id="btnMenu"><i className="material-icons-round">menu</i></button>
                        <div className="btnNecesitoAyuda">
                            <span
                                alt="Si es la primera vez que entras, apretá acá:"
                            >Si es la primera vez que entras, apretá acá:</span>
                            <Link className="btn help" to="/window/decision">
                                <i className="material-icons-round prefix">priority_high</i>
                                NECESITO AYUDA
                            </Link>
                        </div>

                        <nav id="nav">
                            <ul id="menu">
                                <div className="Person">
                                    <img src={avatarPerson} alt="UserAvatar" className="UserAvatar" />
                                    <button id="Username">{this.state.userData.name}<i className="material-icons-round">keyboard_arrow_down</i></button>
                                </div>
                                <div id="PersonOptions">
                                    <Link to="/extra/masInfo"><i className="material-icons-round">add</i>MÁS INFORMACIÓN</Link>
                                    <li onClick={this.logoutHandler}><i className="material-icons-round">power_settings_new</i>CERRAR SESIÓN</li>
                                </div>

                                <div className="TopMenu" style={{ display: "none" }}>
                                    <button className="ThemeButton" id="CloseBTN"><i className="material-icons-round">keyboard_arrow_left</i></button>
                                    <label id="CloseLBL">ATRÁS</label>
                                </div>

                                <div className="List">
                                    <li>
                                        <NavLink className="botonLink" activeClassName="activeLink" to="/user/razones">
                                            <i className="material-icons-round">edit</i>Mis razones para vivir
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink className="botonLink" activeClassName="activeLink" to="/user/plan_seguridad">
                                            <i className="material-icons-round">security</i>Mi plan de seguridad
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink className="botonLink" activeClassName="activeLink" to="/user/imagenes">
                                            <i className="material-icons-round">photo_library</i>Mi galeria de imagenes
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink className="botonLink" activeClassName="activeLink" to="/user/musica">
                                            <i className="material-icons-round">library_music</i>Mi biblioteca de música
                                        </NavLink>
                                    </li>
                                </div>
                                <div className="changeColor">
                                    <button onClick={() => { this.fadeIn() }} className="btn"><i className="material-icons-round prefix">palette</i>Cambiar color</button>
                                </div>
                                <div className="LogoPart">
                                    <Link to="/" className="logo">
                                        <span>Tranqui</span>
                                    </Link>
                                </div>
                            </ul>
                            <div id="blackScreen"></div>
                        </nav>
                    </header>

                    <footer>
                        <ul>
                            {/*<!--Agregar las clase active-->*/}
                            <li><Link to="/user/razones" className="botonLink icon-calendar-check-o"></Link></li>
                            <li><Link to="/user/plan_seguridad" className="botonLink icon-list-ul"></Link></li>
                            <li><Link to="/user/imagenes" className="botonLink icon-picture"></Link></li>
                            <li><Link to="/user/musica" className="botonLink icon-music"></Link></li>
                        </ul>
                    </footer>
                </div>
            )
    }
}
